import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import firebase from "../firebase";

class Profile extends Component {
    state={redirect:false,user:{}};
    componentDidMount(){
        const user = firebase.auth().currentUser;
        (!user) ? this.setState({redirect:true}) : this.setState({user});
    }
    signOut=()=>{
        firebase.auth().signOut();
        this.setState({redirect:true})
    };
    render() {
        const {redirect,user} = this.state;
        if (redirect) {return <Redirect to={'/'} />}
        return (
            <div className="profile">
                <h1>My App</h1>
                <p>Welcome {user.displayName}! You are now signed-in!</p>
                <p>{JSON.stringify(user)}</p>
                <button onClick={this.signOut}>Sign-out</button>
            </div>
        );
    }
}

export default Profile;